import { render, staticRenderFns } from "./CollectionTelMarket.vue?vue&type=template&id=14aec848&scoped=true&"
import script from "./CollectionTelMarket.vue?vue&type=script&lang=js&"
export * from "./CollectionTelMarket.vue?vue&type=script&lang=js&"
import style0 from "./CollectionTelMarket.vue?vue&type=style&index=0&id=14aec848&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14aec848",
  null
  
)

export default component.exports